import React from 'react';
import { TouchableOpacity } from 'react-native';
import { SavedListing } from '@/types/residents/marketplaceListing';
import { COMMUNITY_RESOURCE_ICONS } from '@/assets/admin/CommunityResourceIcons';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';
import { ListingRowCard } from './shared';

const BookmarkFilledIcon = COMMUNITY_RESOURCE_ICONS.bookmarkFilledIcon;

interface SavedListingCardProps {
  listing: SavedListing;
  onPress: () => void;
  onBookmarkPress?: () => void;
}

export const SavedListingCard: React.FC<SavedListingCardProps> = ({
  listing,
  onPress,
  onBookmarkPress,
}) => {
  const handleBookmarkPress = () => {
    if (onBookmarkPress) {
      onBookmarkPress();
    }
  };

  return (
    <ListingRowCard
      imageUri={listing.images[0]?.url}
      price={listing.price}
      title={listing.title}
      condition={listing.condition}
      onPress={onPress}
      isSold={listing.isSold}
      rightElement={
        <TouchableOpacity 
          onPress={handleBookmarkPress}
          activeOpacity={0.7}
          hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
        >
          <BookmarkFilledIcon 
            width={20} 
            height={20} 
            color={MARKETPLACE_COLORS.accentRed} 
          />
        </TouchableOpacity>
      }
    />
  );
};
